export enum PayoutOrderAutomationMode {
  Auto = 'auto',
  Manual = 'manual',
  AutoDisabled = 'auto_disabled',
}
